import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 43 42"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "40",
      height: "40",
      x: "1.716",
      y: "1",
      fill: "#fff",
      rx: "20"
    }, null, -1),
    _createElementVNode("rect", {
      width: "40",
      height: "40",
      x: "1.716",
      y: "1",
      stroke: "#B20FC0",
      "stroke-width": "1.5",
      rx: "20"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#B20FC0",
      d: "M15.143 23.194c.84-.84.522-2.52-.71-3.752-1.233-1.233-2.913-1.55-3.753-.71-.84.84-.522 2.52.71 3.752 1.232 1.233 2.912 1.55 3.753.71ZM32.081 22.484c1.233-1.232 1.55-2.912.71-3.753-.84-.84-2.52-.522-3.752.71-1.233 1.233-1.55 2.913-.71 3.753.84.84 2.52.523 3.752-.71ZM27.511 16.031c.474-1.677-.07-3.298-1.213-3.621-1.143-.323-2.454.774-2.928 2.452-.474 1.677.07 3.298 1.213 3.621 1.143.323 2.454-.774 2.928-2.452ZM20.341 14.862c.474 1.676-.069 3.299-1.213 3.62-1.144.324-2.455-.774-2.928-2.45-.473-1.677.069-3.3 1.213-3.621 1.144-.324 2.455.774 2.928 2.45ZM26.607 24.329c-.537-.393-.92-.957-1.157-1.577a3.573 3.573 0 0 0-6.544-.286 3.43 3.43 0 0 1-1.564 1.55 3.573 3.573 0 0 0-1.964 3.485c.133 1.685 1.469 3.073 3.149 3.262a3.56 3.56 0 0 0 2.047-.372 2.493 2.493 0 0 1 2.293 0 3.577 3.577 0 0 0 2.049.372 3.587 3.587 0 0 0 3.145-3.238 3.559 3.559 0 0 0-1.454-3.195v-.001Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "map-point"}) } }